"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { BpMd, BpLg } from "@nxt-costco-com/forge-design-tokens";
import { calculateImageSizesFromWidth, generateSrcSet } from "./utils.js";
const COMPONENT_NAME = "Image";
const DEFAULT_WIDTHS = [
  {
    mediaQuery: `(max-width: ${BpMd})`,
    width: 320
  },
  {
    mediaQuery: `(max-width: ${BpLg})`,
    width: 768
  },
  {
    width: 1400
  }
];
const DEFAULT_SIZES = calculateImageSizesFromWidth(DEFAULT_WIDTHS);
const Image = ({
  src,
  alt,
  caption,
  widths,
  isSrcSetEnabled = true,
  loading = "lazy",
  ...props
}) => {
  const widthsToUse = widths || DEFAULT_WIDTHS;
  const sizesToUse = useMemo(() => {
    return isSrcSetEnabled && !!widths ? calculateImageSizesFromWidth(widths) : DEFAULT_SIZES;
  }, [isSrcSetEnabled, widths]);
  const srcSet = useMemo(() => {
    try {
      if (isSrcSetEnabled && src) {
        return generateSrcSet(src, widthsToUse);
      }
    } catch {
      return void 0;
    }
  }, [isSrcSetEnabled, widthsToUse, src]);
  const finalImageProps = {
    alt,
    component: "img",
    loading,
    sizes: isSrcSetEnabled && src ? sizesToUse : void 0,
    src,
    srcSet,
    ...props
  };
  if (caption) {
    return /* @__PURE__ */ jsxs(
      "figure",
      {
        role: "group",
        style: {
          margin: 0,
          padding: 0,
          display: "inline-block"
        },
        children: [
          /* @__PURE__ */ jsx(Box, { ...finalImageProps }),
          /* @__PURE__ */ jsx("figcaption", { style: visuallyHidden, children: /* @__PURE__ */ jsx("p", { children: caption }) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(Box, { ...finalImageProps });
};
Image.displayName = COMPONENT_NAME;
export {
  Image
};
